import { FC } from 'react';
import { IconSVG, IconSVGComponentProps } from '../IconComponent';

export const DepositPaychecksSeparate: FC<IconSVGComponentProps> = ({
    ...props
}) => {
    return (
        <IconSVG
            width="58px"
            height="69px"
            viewBox="0 0 58 69"
            fill="none"
            {...props}
        >
            <rect
                x="0.972656"
                y="42.5566"
                width="26"
                height="26"
                rx="1.5"
                fill="#CF7135"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.8118 0.4431 0.2078)' }}
            />
            <rect
                x="31.9844"
                y="32.5566"
                width="26"
                height="26"
                rx="1.5"
                fill="#6DBBF3"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.4275 0.7333 0.9529)' }}
            />
            <path
                d="M14.4463 10.5566C14.4463 10.1424 14.1105 9.80664 13.6963 9.80664C13.2821 9.80664 12.9463 10.1424 12.9463 10.5566L14.4463 10.5566ZM13.166 32.253C13.4589 32.5459 13.9337 32.5459 14.2266 32.253L18.9996 27.48C19.2925 27.1871 19.2925 26.7122 18.9996 26.4194C18.7067 26.1265 18.2318 26.1265 17.9389 26.4194L13.6963 30.662L9.45365 26.4194C9.16076 26.1265 8.68588 26.1265 8.39299 26.4194C8.1001 26.7122 8.1001 27.1871 8.39299 27.48L13.166 32.253ZM12.9463 10.5566L12.9463 31.7227L14.4463 31.7227L14.4463 10.5566L12.9463 10.5566Z"
                fill="#C0C2C6"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.7529 0.7600 0.7780)' }}
            />
            <path
                d="M44.7344 0.972656C44.7344 0.558443 44.3986 0.222656 43.9844 0.222656C43.5702 0.222656 43.2344 0.558443 43.2344 0.972656L44.7344 0.972656ZM43.454 22.669C43.7469 22.9619 44.2218 22.9619 44.5147 22.669L49.2877 17.896C49.5806 17.6031 49.5806 17.1283 49.2877 16.8354C48.9948 16.5425 48.5199 16.5425 48.227 16.8354L43.9844 21.078L39.7417 16.8354C39.4488 16.5425 38.974 16.5425 38.6811 16.8354C38.3882 17.1283 38.3882 17.6031 38.6811 17.896L43.454 22.669ZM43.2344 0.972656L43.2344 22.1387L44.7344 22.1387L44.7344 0.972656L43.2344 0.972656Z"
                fill="#C0C2C6"
                fillOpacity={1}
                strokeWidth={0}
                style={{ fill: 'color(display-p3 0.7529 0.7600 0.7780)' }}
            />
        </IconSVG>
    );
};
